import {
  ExperimentOutlined,
  FileAddOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  IssuesCloseOutlined,
  MedicineBoxOutlined,
  PieChartOutlined,
  PrinterOutlined,
  ProfileOutlined,
  ReadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { TEST_STATUS } from "utils/Config";
import { UserRoleEnums } from "utils/Constant";
import IntlMessages from "utils/IntlMessages";
import { hasAnyRole, isCurrentRole } from "./menuHelpers";

const { ItemGroup: MenuItemGroup, Item: MenuItem } = Menu;

const GeneralProgramMenuSection = ({ roles, role, countUi }) => {
  const { SUPERVISOR, DATA_ANALYST, RECEPTIONIST, DATA_CLERK, ANALYST, ADMIN } =
    UserRoleEnums;

  return (
    <>
      <MenuItemGroup
        key="analytics"
        className="gx-menu-group"
        title={<IntlMessages id="sidebar.analytics" />}
      >
        <>
          <MenuItem key="clinical/dashboard">
            <Link to="/clinical/dashboard">
              <PieChartOutlined className="icon" />
              <span>
                <IntlMessages id="sidebar.dashboard" />
              </span>
            </Link>
          </MenuItem>
          <MenuItem key="clinical/report">
            <Link to="/clinical/report">
              <ReadOutlined className="icon" />
              <span>
                <IntlMessages id="sidebar.report" />
              </span>
            </Link>
          </MenuItem>
          {(role === SUPERVISOR || role === DATA_ANALYST) && (
            <MenuItem key="enlis/manage-result">
              <Link to="/manage-result">
                <FileDoneOutlined className="icon" />
                <span>
                  <IntlMessages id="sidebar.manageResult" />
                  {countUi(TEST_STATUS.RESULT.APPROVAL)}
                </span>
              </Link>
            </MenuItem>
          )}
        </>
      </MenuItemGroup>

      {hasAnyRole(roles, SUPERVISOR, RECEPTIONIST, DATA_CLERK, ANALYST) &&
        isCurrentRole(role, SUPERVISOR, RECEPTIONIST, DATA_CLERK, ANALYST) && (
          <MenuItemGroup
            key="clinical"
            className="gx-menu-group"
            title={<IntlMessages id="sidebar.main" />}
          >
            <>
              {hasAnyRole(roles, SUPERVISOR, RECEPTIONIST, DATA_CLERK) &&
                isCurrentRole(role, SUPERVISOR, RECEPTIONIST, DATA_CLERK) && (
                  <>
                    <MenuItem key="clinical/complete-entry">
                      <Link to="/clinical/complete-entry">
                        <FileAddOutlined className="icon icon-widgets" />
                        <span>Retrospective Data Entry</span>
                      </Link>
                    </MenuItem>
                    <MenuItem key="clinical/lab-order">
                      <Link to="/clinical/lab-order">
                        <UserOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.manageClient" />
                        </span>
                      </Link>
                    </MenuItem>
                    <MenuItem key="clinical/manage-sample">
                      <Link to="/clinical/manage-sample">
                        <ExperimentOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.collection" />
                          {countUi([
                            TEST_STATUS.SAMPLE.APPROVED,
                            TEST_STATUS.SAMPLE.ORDERED,
                          ])}
                        </span>
                      </Link>
                    </MenuItem>
                  </>
                )}
              {hasAnyRole(roles, SUPERVISOR, RECEPTIONIST) &&
                isCurrentRole(role, SUPERVISOR, RECEPTIONIST) && (
                  <MenuItem key="clinical/sample-reception">
                    <Link to="/clinical/sample-reception">
                      <MedicineBoxOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.sampleReception" />
                      </span>
                    </Link>
                  </MenuItem>
                )}
              {hasAnyRole(roles, SUPERVISOR, ANALYST) &&
                isCurrentRole(role, ANALYST, SUPERVISOR) && (
                  <MenuItem key="clinical/workplan">
                    <Link to="/clinical/workplan">
                      <PrinterOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.workplan" />
                        {countUi(TEST_STATUS.SAMPLE.APPROVED)}
                      </span>
                    </Link>
                  </MenuItem>
                )}
              {hasAnyRole(roles, DATA_CLERK, SUPERVISOR, ANALYST) &&
                isCurrentRole(role, DATA_CLERK, ADMIN, ANALYST, SUPERVISOR) && (
                  <MenuItem key="clinical/enter-results">
                    <Link to="/clinical/enter-results">
                      <ProfileOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.manualResults" />
                        {countUi(TEST_STATUS.SAMPLE.APPROVED)}
                      </span>
                    </Link>
                  </MenuItem>
                )}
              {roles.includes(SUPERVISOR) &&
                isCurrentRole(role, SUPERVISOR) && (
                  <MenuItem key="clinical/validate-results">
                    <Link to="/clinical/validate-results">
                      <IssuesCloseOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.validateResults" />
                        {countUi(TEST_STATUS.RESULT.ENTERED)}
                      </span>
                    </Link>
                  </MenuItem>
                )}
              {hasAnyRole(roles, SUPERVISOR) &&
                isCurrentRole(role, SUPERVISOR) && (
                  <MenuItem key="clinical/approve-results">
                    <Link to="/clinical/approve-results">
                      <FileProtectOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.approveResults" />
                        {countUi(TEST_STATUS.RESULT.VERIFIED)}
                      </span>
                    </Link>
                  </MenuItem>
                )}
            </>
          </MenuItemGroup>
        )}
    </>
  );
};

export default GeneralProgramMenuSection;

GeneralProgramMenuSection.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  role: PropTypes.string,
  countUi: PropTypes.func.isRequired,
};
